import { Route } from "react-router-dom";
import ManagerValidationLeaveRequest from "../features/validate_leave_request";
import ManagerValidationTimeReporting from "../features/validate_time_reporting";
import ManagerValidationExpenseReport from "../features/validate_expenses_report";

export const approvalsRoutes = (
    <>
        <Route
            path="/timesheet_approval/:hash"
            element={<ManagerValidationTimeReporting />}
            key="time_reporting_approval"
        />
        <Route
            path="/leave_request_approval/:hash"
            element={<ManagerValidationLeaveRequest />}
            key="leave_request_approval"
        />
        <Route
            path="/expense-report-approval/:hash"
            element={<ManagerValidationExpenseReport />}
            key="expense_report_approval"
        />
    </>
);
